import type { BusinessTerm } from '@wix/ambassador-funnel-taxonomy-v1-business-term/types'
import { tryCatch } from '@wix/funnel-utils'

import { BusinessTermService } from '../../reusable/Category/api/BusinessTermService'

export type MatchedBusinessTerm = {
  businessTerm: BusinessTerm
  businessSegmentId?: string
}

export const matchBusinessTermFromText = async ({
  businessTermService,
  text,
  language,
}: {
  businessTermService: BusinessTermService
  text: string
  language: string
}): Promise<MatchedBusinessTerm | null> => {
  const query = text.trim()
  if (!query) {
    return null
  }

  const [, results] = await tryCatch(() => businessTermService.search({ query, limit: 1, language }))
  const businessTerm = results?.[0]
  if (!businessTerm) {
    return null
  }

  const businessSegmentId = businessTerm.businessTermId
    ? await businessTermService.getBusinessSegmentIdByTermId(businessTerm.businessTermId)
    : undefined

  return { businessTerm, businessSegmentId }
}
